var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingConfiguration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85156 7.6485C5.54106 7.6485 5.28906 7.3965 5.28906 7.086V5.47575C5.29881 3.27225 7.08081 1.5 9.26556 1.5H9.28056C10.9726 1.5 12.4831 2.57475 13.0373 4.17525C13.1393 4.4685 12.9833 4.78875 12.6893 4.89075C12.3961 4.9935 12.0758 4.83675 11.9738 4.54275C11.5771 3.396 10.4933 2.625 9.27831 2.625H9.26781C7.69881 2.625 6.42081 3.8955 6.41406 5.463V7.086C6.41406 7.3965 6.16206 7.6485 5.85156 7.6485Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4065 7.59375C5.148 7.59375 4.125 8.6175 4.125 9.876V13.092C4.125 14.3505 5.148 15.3742 6.4065 15.3742H12.138C13.3958 15.3742 14.4195 14.3505 14.4195 13.092V9.876C14.4195 8.6175 13.3958 7.59375 12.138 7.59375H6.4065ZM12.138 16.4992H6.4065C4.52775 16.4992 3 14.9708 3 13.092V9.876C3 7.99725 4.52775 6.46875 6.4065 6.46875H12.138C14.016 6.46875 15.5445 7.99725 15.5445 9.876V13.092C15.5445 14.9708 14.016 16.4992 12.138 16.4992Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27344 12.8813C8.96294 12.8813 8.71094 12.6293 8.71094 12.3188V10.6523C8.71094 10.3418 8.96294 10.0898 9.27344 10.0898C9.58394 10.0898 9.83594 10.3418 9.83594 10.6523V12.3188C9.83594 12.6293 9.58394 12.8813 9.27344 12.8813Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingConfiguration);
export default __webpack_public_path__ + "static/media/settingConfiguration.9a88a397.svg";
export { ForwardRef as ReactComponent };